module.exports = __webpack_public_path__ + "static/media/root_file_manager.99159c3a.png";